import './Loader.css'

const Loader = () => {

  return(
    <div className='loader'>
      <h2 className='loader__titule'>
        <span className='loader__titule-1'>"Our technology is part of our humanity."</span><br />
        <span className='loader__titule-2'>- Ray Kurzweil</span>
      </h2>
    </div>
  )
}

export default Loader
